import { Component, Input, Output } from '@angular/core';
import { PageService } from '../../../services/page.service';

@Component({
  selector: 'mob-box-info',
  templateUrl: './box-info.component.html',
  styleUrls: ['./box-info.component.scss']
})
export class BoxInfoComponent {

    @Input() title: Array<any>;
    @Input() description?:string;
    @Input() icon:string = 'sys-002';
    @Input() hasBorder:boolean = true;
    @Input() linkText?:string = '';
    @Input() url?:string = '';

    constructor() { }

}
